module.exports = __webpack_public_path__ + "static/media/back.64ac4394.svg";